export type SearchItem = {
  item_type: string;
  pair?: string;
  origin?: string;
  destination?: string;
  outdate?: string;
  outhour?: string;
  outmin?: string;
  outtype?: string;
  homedate?: string;
  homehour?: string;
  homemin?: string;
  hometype?: string;
  checkin_date?: string;
  checkout_date?: string;
  destination_address?: string;
};

export type BlockerCategory = 'outward' | 'homeward' | 'hotel';
export type BlockerType = 'missing_field' | 'date_confirmation' | 'date_validation_error';

export const BLOCKER_CATEGORIES: readonly BlockerCategory[] = ['outward', 'homeward', 'hotel'] as const;

export const BLOCKER_CATEGORY_LABELS: Record<BlockerCategory, string> = {
  outward: '行きの交通',
  homeward: '帰りの交通',
  hotel: 'ホテル'
};

export type BlockerKey =
  | 'outward_origin'
  | 'outward_destination'
  | 'outward_outdate'
  | 'outward_departure_time'
  | 'outward_arrival_time'
  | 'homeward_origin'
  | 'homeward_destination'
  | 'homeward_outdate'
  | 'homeward_departure_time'
  | 'homeward_arrival_time'
  | 'hotel_destination'
  | 'hotel_checkin_date';

export type Blocker = {
  key: string;
  category: BlockerCategory;
  type: BlockerType;
  raw?: string;
  assumedDate?: string;
  message?: string;
};

export type DecidedField = {
  key: string;
  category: BlockerCategory;
  label: string;
  value: string;
};

export type ConversationState = {
  currentSearchParams: {
    items?: Record<string, SearchItem>;
    searchTargets?: string[];
  };
  missingFields: string[];
  dateValidationErrors: string[];
  searchTargets: string[];
  readyToSearch: boolean;
  updatedAt: string | null;
  blockers: Blocker[];
  decidedFields: DecidedField[];
};
